import { createWebHistory, createRouter } from "vue-router";
import store from "../store";
import { matchMenu } from "../utils/menu-context";
import { setIsLoading, state as stateApp, clearModal } from "../app.logic";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import moment from "moment";
import { notification } from "ant-design-vue";
import i18n from "../i18n";

const RouteView = {
    render: () => <router-view></router-view>,
};

const routeData = [
    {
        path: "",
        name: "index",
        redirect: { name: "app" },
    },
    {
        path: "/app",
        name: "app",
        redirect: { name: "home" },
        component: () => import("../components/layout/app-layout/AppLayout"),
        children: [
            {
                path: "home",
                name: "home",
                //component: () => import("../views/app/home/Home"),
                component: () => import("../views/menu-list/MenuList"),
            },
            {
                path: "notifications",
                redirect: { name: "notifications" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "notifications",
                        component: () => import("../views/app/notification/NotificationList")
                    }
                ]
            },
            {
                path: "profile",
                redirect: { name: "profile" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "profile",
                        component: () => import("../views/app/profile/ProfileForm"),
                    },
                ],
            },
            {
                path: "user-insteads",
                redirect: { name: "user-insteads" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "user-insteads",
                        component: () => import("../views/app/user-instead/UserInsteadList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "user-insteads-create",
                        component: () => import("../views/app/user-instead/UserInsteadForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/edit",
                        name: "user-insteads-edit",
                        component: () => import("../views/app/user-instead/UserInsteadForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/view",
                        name: "user-insteads-view",
                        component: () => import("../views/app/user-instead/UserInsteadForm"),
                        props: (route) => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                    },
                ],
            },
            {
                path: "user-requests",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "user-requests",
                        component: () => import("../views/app/user-request/request-register/UserRequestRegisterList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "user-requests-create",
                        component: () => import("../views/app/user-request/request-register/UserRequestRegisterForm"),
                        props: (route) => ({
                            ...JSON.parse(route.params?.props || null),
                        }),
                    },
                    {
                        path: ":id/edit",
                        name: "user-requests-edit",
                        component: () => import("../views/app/user-request/request-register/UserRequestRegisterForm"),
                        props: (route) => ({
                            ...JSON.parse(route.params?.props || null),
                        }),
                    },
                    {
                        path: ":id/view",
                        name: "user-requests-view",
                        component: () => import("../views/app/user-request/request-register/UserRequestRegisterForm"),
                        props: (route) => ({
                            viewOnly: true,
                            ...JSON.parse(route.params?.props || null),
                        }),
                    },
                ],
            },
            {
                path: "fee-statements",
                redirect: { name: "fee-statements" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "fee-statements",
                        component: () => import("../views/app/fee-statement/request/RequestList"),
                        props: route => ({
                            ...JSON.parse(route.params?.props || null),
                        })
                    },
                    {
                        path: "create",
                        name: "fee-statements-create",
                        component: () => import("../views/app/fee-statement/request/RequestForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/edit",
                        name: "fee-statements-edit",
                        meta: { isPublic: true },
                        component: () => import("../views/app/fee-statement/request/RequestForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/view",
                        name: "fee-statements-view",
                        component: () => import("../views/app/fee-statement/request/RequestForm"),
                        props: { viewOnly: true }
                    }
                ]
            },
            {
                path: "data-mgt",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "data-mgt",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true },
                    },
                    {
                        path: "departments",
                        redirect: { name: "departments" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "departments",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentList"),
                            },
                            {
                                path: "create",
                                name: "departments-create",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                            },
                            {
                                path: ":id/edit",
                                name: "departments-edit",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                            },
                            {
                                path: ":id/view",
                                name: "departments-view",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            },
                        ],
                    },
                    {
                        path: "lookups",
                        redirect: { name: "lookups" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lookups",
                                component: () => import("../views/app/setting/data-mgt/lookup/LookupIconList"),
                            },
                            {
                                path: ":group",
                                component: {
                                    render: () => <router-view></router-view>,
                                    setup() {
                                        const route = useRoute();
                                        const { createGroupTitle } = require("../views/app/setting/data-mgt/lookup/lookup.logic");
                                        const group = route.params.group;
                                        const title = computed(() => createGroupTitle({ group }));
                                        return { title };
                                    },
                                },
                                children: [
                                    {
                                        path: "",
                                        name: "lookups-group",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupList"),
                                    },
                                    {
                                        path: "create",
                                        name: "lookups-create",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "lookups-edit",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                    },
                                    {
                                        path: ":id/view",
                                        name: "lookups-view",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "fishing-tools",
                        redirect: { name: "fishing-tools" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "fishing-tools",
                                component: () => import("../views/app/setting/data-mgt/fishing-tool/FishingToolList"),
                                props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                            },
                            {
                                path: "create",
                                name: "fishing-tools-create",
                                component: () => import("../views/app/setting/data-mgt/fishing-tool/FishingToolForm"),
                                props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                            },
                            {
                                path: ":id/edit",
                                name: "fishing-tools-edit",
                                component: () => import("../views/app/setting/data-mgt/fishing-tool/FishingToolForm"),
                                props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                            },
                            {
                                path: ":id/view",
                                name: "fishing-tools-view",
                                component: () => import("../views/app/setting/data-mgt/fishing-tool/FishingToolForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            },
                        ],
                    },
                    {
                        path: "reports",
                        redirect: { name: "reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "reports",
                                component: () => import("../views/app/setting/data-mgt/report-mgt/ReportList"),
                            },
                            {
                                path: "create",
                                name: "reports-create",
                                component: () => import("../views/app/setting/data-mgt/report-mgt/ReportForm"),
                            },
                            {
                                path: ":id/edit",
                                name: "reports-edit",
                                component: () => import("../views/app/setting/data-mgt/report-mgt/ReportForm"),
                            },
                            {
                                path: ":id/view",
                                name: "reports-view",
                                component: () => import("../views/app/setting/data-mgt/report-mgt/ReportForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            },
                        ],
                    },
                ],
            },
            {
                path: "events",
                redirect: { name: "events" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "events",
                        component: () => import("../views/app/event/EventList"),
                    },
                    {
                        path: ":id/view",
                        name: "events-view",
                        component: () => import("../views/app/event/EventForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
            {
                path: "security-events",
                redirect: { name: "security-events" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "security-events",
                        component: () => import("../views/app/security-event/SecurityEventList")
                    },
                    {
                        path: ":id/view",
                        name: "security-events-view",
                        component: () => import("../views/app/security-event/SecurityEventForm"),
                        props: { viewOnly: true }
                    }
                ]
            },
            {
                path: "faqs",
                redirect: { name: "faqs" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "faqs",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/faq/FaqList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "faqs-create",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/faq/FaqForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/edit",
                        name: "faqs-edit",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/faq/FaqForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/view",
                        name: "faqs-view",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/faq/FaqForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
            {
                path: "file-stores",
                redirect: { name: "file-stores" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "file-stores",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/file-store/FileStoreList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "file-stores-create",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/file-store/FileStoreForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/edit",
                        name: "file-stores-edit",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/file-store/FileStoreForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/view",
                        name: "file-stores-view",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/file-store/FileStoreForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
            {
                path: "news",
                redirect: { name: "news" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "news",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/news-notification/NewsNotificationList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "news-create",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/news-notification/NewsNotificationForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/edit",
                        name: "news-edit",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/news-notification/NewsNotificationForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/view",
                        name: "news-view",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/news-notification/NewsNotificationForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
            {
                path: "laws",
                redirect: { name: "laws" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "laws",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/law/LawList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "laws-create",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/law/LawForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/edit",
                        name: "laws-edit",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/law/LawForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/view",
                        name: "laws-view",
                        meta: { isPublic: true },
                        component: () => import("../views/app/setting/data-mgt/law/LawForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
            {
                path: "reports",
                redirect: { name: "report" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "report",
                        meta: { isPublic: true },
                        component: () => import("../views/app/report/ReportForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null), ...route.query })
                    },
                ]
            },
            {
                path: "setting",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "setting",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true },
                    },
                    {
                        path: "user-mgt",
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "user-mgt",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true },
                            },
                            {
                                path: "users",
                                redirect: { name: "users" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "users",
                                        component: () => import("../views/app/setting/user-mgt/user/UserList"),
                                    },
                                    {
                                        path: "create",
                                        name: "users-create",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "users-edit",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                    },
                                    {
                                        path: ":id/view",
                                        name: "users-view",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    },
                                ],
                            },
                            {
                                path: "roles",
                                redirect: { name: "roles" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "roles",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleList"),
                                    },
                                    {
                                        path: "create",
                                        name: "roles-create",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "roles-edit",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                    },
                                    {
                                        path: ":id/view",
                                        name: "roles-view",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    },
                                ],
                            },
                            {
                                path: "resources",
                                redirect: { name: "resources" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "resources",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceList"),
                                    },
                                    {
                                        path: "create",
                                        name: "resources-create",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "resources-edit",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                    },
                                    {
                                        path: ":id/view",
                                        name: "resources-view",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    },
                                ],
                            },
                            {
                                path: "menus",
                                redirect: { name: "menus" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "menus",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuList"),
                                    },
                                    {
                                        path: "create",
                                        name: "menus-create",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "menus-edit",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                    },
                                    {
                                        path: ":id/view",
                                        name: "menus-view",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: "menu-sides",
                        redirect: { name: "menu-sides" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "menu-sides",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideList"),
                            },
                            {
                                path: "create",
                                name: "menu-sides-create",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                            },
                            {
                                path: ":id/edit",
                                name: "menu-sides-edit",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                            },
                            {
                                path: ":id/view",
                                name: "menu-sides-view",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            },
                        ],
                    },
                    {
                        path: "application",
                        redirect: { name: "application" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "application",
                                component: () => import("../views/app/setting/application/Application"),
                            },
                        ],
                    },
                ],
            },
            {
                path: "otp-logs",
                redirect: { name: "otp-logs" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "otp-logs",
                        component: () => import("../views/app/otp-log/OtpList"),
                    },
                ],
            },
            {
                path: "license-requests",
                redirect: { name: "license-requests" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "license-requests",
                        component: () => import("../views/app/license-request/request/RequestList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "license-requests-create",
                        component: () => import("../views/app/license-request/request/license/RequestForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                        meta: { isCheckIdCardExpire: true }
                    },
                    {
                        path: ":id/edit",
                        name: "license-requests-edit",
                        component: () => import("../views/app/license-request/request/license/RequestForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) }),
                        meta: { isCheckIdCardExpire: true }
                    },
                    {
                        path: ":id/view",
                        name: "license-requests-view",
                        component: () => import("../views/app/license-request/request/license/RequestForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: "changes",
                        component: RouteView,
                        children: [
                            {
                                path: "create",
                                name: "change-license-requests-create",
                                component: () => import("../views/app/license-request/request/change-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/edit",
                                name: "change-license-requests-edit",
                                component: () => import("../views/app/license-request/request/change-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/view",
                                name: "change-license-requests-view",
                                component: () => import("../views/app/license-request/request/change-license/RequestForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "renews",
                        component: RouteView,
                        children: [
                            {
                                path: "create",
                                name: "renew-license-requests-create",
                                component: () => import("../views/app/license-request/request/renew-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/edit",
                                name: "renew-license-requests-edit",
                                component: () => import("../views/app/license-request/request/renew-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/view",
                                name: "renew-license-requests-view",
                                component: () => import("../views/app/license-request/request/renew-license/RequestForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "replacements",
                        component: RouteView,
                        children: [
                            {
                                path: "create",
                                name: "replacement-license-requests-create",
                                component: () => import("../views/app/license-request/request/replacement-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/edit",
                                name: "replacement-license-requests-edit",
                                component: () => import("../views/app/license-request/request/replacement-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/view",
                                name: "replacement-license-requests-view",
                                component: () => import("../views/app/license-request/request/replacement-license/RequestForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "cancels",
                        component: RouteView,
                        children: [
                            {
                                path: "create",
                                name: "cancel-license-requests-create",
                                component: () => import("../views/app/license-request/request/cancel-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/edit",
                                name: "cancel-license-requests-edit",
                                component: () => import("../views/app/license-request/request/cancel-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/view",
                                name: "cancel-license-requests-view",
                                component: () => import("../views/app/license-request/request/cancel-license/RequestForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "transfers",
                        component: RouteView,
                        children: [
                            {
                                path: "create",
                                name: "transfer-license-requests-create",
                                component: () => import("../views/app/license-request/request/transfer-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/edit",
                                name: "transfer-license-requests-edit",
                                component: () => import("../views/app/license-request/request/transfer-license/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                meta: { isCheckIdCardExpire: true }
                            },
                            {
                                path: ":id/view",
                                name: "transfer-license-requests-view",
                                component: () => import("../views/app/license-request/request/transfer-license/RequestForm"),
                                props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                ],
            },
            {
                path: "licenses",
                redirect: { name: "licenses" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "licenses",
                        component: () => import("../views/app/license/LicenseList"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/view",
                        name: "licenses-view",
                        component: () => import("../views/app/license/LicenseForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/edit",
                        name: "licenses-edit",
                        component: () => import("../views/app/license/LicenseForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
            {
                path: "my-jobs",
                redirect: { name: "my-jobs" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "my-jobs",
                        component: () => import("../views/app/license-request/my-job/MyJobList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null), routerPrefix: "my-jobs" }),
                    },
                    {
                        path: ":id/edit",
                        name: "my-jobs-edit",
                        component: () => import("../views/app/license-request/request/license/RequestForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null), routerPrefix: "my-jobs"  }),
                    },
                    {
                        path: ":id/view",
                        name: "my-jobs-view",
                        component: () => import("../views/app/license-request/request/license/RequestForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: "changes/:id/edit",
                        name: "change-my-jobs-edit",
                        component: () => import("../views/app/license-request/request/change-license/RequestForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null),  routerPrefix:  "change-my-jobs"  }),
                    },
                    {
                        path: "changes/:id/view",
                        name: "change-my-jobs-view",
                        component: () => import("../views/app/license-request/request/change-license/RequestForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null),  routerPrefix:  "change-my-jobs"  })
                    },
                    {
                        path: "replacements/:id/edit",
                        name: "replacement-my-jobs-edit",
                        component: () => import("../views/app/license-request/request/replacement-license/RequestForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null),  routerPrefix:  "replacement-my-jobs"  }),
                    },
                    {
                        path: "replacements/:id/view",
                        name: "replacement-my-jobs-view",
                        component: () => import("../views/app/license-request/request/replacement-license/RequestForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null),  routerPrefix:  "replacement-my-jobs" })
                    },
                    {
                        path: "cancels/:id/edit",
                        name: "cancel-my-jobs-edit",
                        component: () => import("../views/app/license-request/request/cancel-license/RequestForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null),  routerPrefix:  "cancel-my-jobs" }),
                    },
                    {
                        path: "cancels/:id/view",
                        name: "cancel-my-jobs-view",
                        component: () => import("../views/app/license-request/request/cancel-license/RequestForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null),  routerPrefix:  "cancel-my-jobs" })
                    },
                    {
                        path: "transfers/:id/edit",
                        name: "transfer-my-jobs-edit",
                        component: () => import("../views/app/license-request/request/transfer-license/RequestForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null), routerPrefix: "transfer-my-jobs" }),
                    },
                    {
                        path: "transfers/:id/view",
                        name: "transfer-my-jobs-view",
                        component: () => import("../views/app/license-request/request/transfer-license/RequestForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null), routerPrefix: "transfer-my-jobs" })
                    },
                    {
                        path: "renews/:id/edit",
                        name: "renew-my-jobs-edit",
                        component: () => import("../views/app/license-request/request/renew-license/RequestForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null), routerPrefix: "renew-my-jobs" }),
                    },
                    {
                        path: "renews/:id/view",
                        name: "renew-my-jobs-view",
                        component: () => import("../views/app/license-request/request/renew-license/RequestForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null), routerPrefix: "renew-my-jobs" })
                    },
                ],
            },
            {
                path: "surveys",
                redirect: { name: "surveys" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "surveys",
                        component: () => import("../views/app/survey/SurveyList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "surveys-create",
                        component: () => import("../views/app/survey/SurveyForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/edit",
                        name: "surveys-edit",
                        component: () => import("../views/app/survey/SurveyForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/view",
                        name: "surveys-view",
                        component: () => import("../views/app/survey/SurveyForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
            {
                path: "survey-answers",
                redirect: { name: "survey-answers" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "survey-answers",
                        component: () => import("../views/app/survey-answer/SurveyAnswerList"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: "create",
                        name: "survey-answers-create",
                        component: () => import("../views/app/survey-answer/SurveyAnswerForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/edit",
                        name: "survey-answers-edit",
                        component: () => import("../views/app/survey-answer/SurveyAnswerForm"),
                        props: (route) => ({ ...JSON.parse(route.params?.props || null) }),
                    },
                    {
                        path: ":id/view",
                        name: "survey-answers-view",
                        component: () => import("../views/app/survey-answer/SurveyAnswerForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },

                    {
                        path: ":id/createForm",
                        name: "survey-answers-create-form",
                        component: () => import("../views/app/survey-answer/SurveyAnswerForm"),
                        props: route => ({  viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    },
                ],
            },
        ],
    },
    {
        path: "/account",
        name: "account",
        redirect: { name: "login" },
        meta: { isPublic: true },
        component: () => import("../components/layout/account-layout/AccountLayout"),
        children: [
            {
                path: "login",
                name: "login",
                meta: { isPublic: true },
                component: () => import("../views/account/login/Login"),
            },
            {
                path: "forgot-password",
                name: "forgot-password",
                meta: { isPublic: true },
                component: () => import("../views/account/login/ForgotPassword"),
            },
            {
                path: "active-forgot-password",
                name: "active-forgot-password",
                meta: { isPublic: true },
                component: () => import("../views/account/login/ActiveForgotPassword"),
                props: route => ({ ...JSON.parse(route.params?.props || null) })
            },
        ],
    },
    {
        path: "/register",
        name: "register",
        meta: { isPublic: true },
        component: () => import("../views/account/register/Register"),
    },
    {
        path: "/pdpa",
        name: "pdpa",
        meta: { isPublic: true },
        component: () => import("../views/account/pdpa/PdpaForm"),
    },
    {
        path: "/active-email-token",
        name: "active-email-token",
        meta: { isPublic: true },
        component: () => import("../views/account/register/ActiveEmailToken"),
    },
    {
        path: "/register-fisherman",
        name: "register-fisherman",
        meta: { isPublic: true },
        component: () => import("../views/account/register-fisherman/RegisterFisherman"),
    },
    {
        path: "/register-officer",
        name: "register-officer",
        meta: { isPublic: true },
        component: () => import("../views/account/register-manager/RegisterManager"),
    },
    {
        path: "/register-people",
        name: "register-people",
        meta: { isPublic: true },
        component: () => import("../views/account/register-people/RegisterPeople"),
    },
    {
        path: "/403",
        name: "403",
        meta: { isPublic: true },
        component: () => import("../views/error/403"),
    },
    {
        path: "/500",
        name: "500",
        meta: { isPublic: true },
        component: () => import("../views/error/500"),
    },
    {
        path: "/:pathMatch(.*)*",
        name: "404",
        meta: { isPublic: true },
        component: () => import("../views/error/404"),
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routeData,
});

const clearCacheQuery = (to, from, roleMenus) => {
    const menuContext = matchMenu(from.path, roleMenus);
    if (menuContext && menuContext.query) {
        if (menuContext.query.cacheQuery !== "true") {
            menuContext.query = null;
        }
    }
};

router.beforeEach((to, from, next) => {
    let allow = false;
    if (to.meta.isPublic) {
        allow = true;
    }
    if (to?.path !== from?.path) {
        setIsLoading(true);
    }
    const getRoleMenu = ref(null);
    const isAuth = store.getters["resource/auth/isAuth"];
    if (to.meta.isAuth && isAuth) {
        allow = true;
    }
    if (isAuth) {
        getRoleMenu.value = store.dispatch("resource/auth/getInfo", {});
        store.dispatch("resource/auth/setIntervalLogout", {});
    } else {
        getRoleMenu.value = store.dispatch("resource/anonymous/getInfo", {});
    }
    getRoleMenu.value
        .then((info) => {
            stateApp.authInfo = info;
            const roleMenus = info.menus;
            clearCacheQuery(to, from, roleMenus);
            const match = matchMenu(to.path, roleMenus);
            stateApp.menuContext = match;

            if(to.meta.isCheckIdCardExpire) {
                const userInfo = info.user;
                if(userInfo.expireDate && moment().isAfter(moment(userInfo.expireDate, ["YYYY-MM-DD"], true))) {
                    notification["error"]({ message: i18n.global.t("error.form.idCardExpire") });
                    next(from);
                    return;
                }
            }

            if (allow) {
                next();
            } else if (!match) {
                if (isAuth) {
                    next({ name: "403", query: { url: from.fullPath } });
                } else {
                    next({ name: "login", query: { url: to.fullPath } });
                }
            } else {
                if (Object.keys(to.query).length > 0) {
                    match.query = to.query;
                }
                next();
            }
        })
        .finally(() => {
            clearModal();
            setTimeout(() => setIsLoading(false, 500));
        });
});

export { router as default, routeData };
